import React, { useEffect, useState } from "react";
import { Button, Radio, RadioGroup, Space, TextInput } from "@mantine/core";
import TagMultiSelect from "../../tags/elements/TagMultiSelect";
import SegmentSelector from "../../../common/components/SegmentSelector";
import ScheduleDateTimeInput from "../../../themes/elements/ScheduleDateTimeInput";
import CreateSurveyButton from "../elements/CreateSurveyButton";
import { SurveyFormInterface } from "./SurveyForm";

type SurveyDetailsFormProps = {
  form: SurveyFormInterface;
  isLoading: boolean;
  showSegmentationToggle: boolean;
  targetingType: "tags" | "segments";
  setTargetingType: (type: "tags" | "segments") => void;
  segmentIds: string[];
  setSegmentIds: (ids: string[]) => void;
  onSaveDraft: () => void;
  onPublish: () => void;
};

const SurveyDetailsForm: React.FC<SurveyDetailsFormProps> = ({
  form,
  isLoading,
  showSegmentationToggle,
  targetingType,
  setTargetingType,
  segmentIds,
  setSegmentIds,
  onSaveDraft,
  onPublish,
}) => {
  const [tagIds, setTagIds] = useState<number[]>([]);
  useEffect(() => {
    setTagIds(form.values.tags.map((tagId) => Number(tagId)));
  }, [form.values.tags]);

  return (
    <>
      <TextInput required label="Name" {...form.getInputProps("title")} />
      <Space h="xl" />

      {/* Audience Selection */}
      <div>
        <div className="font-medium text-[14px] text-[#062133] mb-2">
          Select employee audience <span className="text-[#ED7687]">*</span>
        </div>
        <p className="text-[12px] text-[#839099] mb-3">
          Choose which employee groups should receive this survey
        </p>

        {/* Targeting Type Toggle - Only show if segmentation is enabled */}
        {showSegmentationToggle && (
          <>
            <RadioGroup
              value={targetingType}
              onChange={(value: "tags" | "segments") => setTargetingType(value)}
              color="jem-theme"
              size="xs"
              orientation="horizontal"
              spacing="sm"
            >
              <Radio value="segments" label="Segments" />
              <Radio value="tags" label="Tags" />
            </RadioGroup>
            <Space h="md" />
          </>
        )}

        {/* Conditional Rendering based on targeting type */}
        {showSegmentationToggle && targetingType === "segments" ? (
          <SegmentSelector
            value={segmentIds}
            onChange={setSegmentIds}
            label=""
            description=""
            placeholder="Select segments"
          />
        ) : (
          <TagMultiSelect form={form} />
        )}
      </div>

      <Space h="xl" />
      <ScheduleDateTimeInput
        form={form}
        description="Choose how long to keep the survey open"
      />
      <Space h="xl" />
      <Space h="xl" />
      <Button
        fullWidth
        color="#6C6C7F"
        type="button"
        variant="outline"
        loading={isLoading}
        onClick={onSaveDraft}
      >
        Save Draft and Exit
      </Button>
      <Space h="xl" />
      <CreateSurveyButton
        onClick={onPublish}
        tagIds={tagIds}
        segmentIds={segmentIds.map((id) => Number(id))}
        targetingType={targetingType}
        loading={isLoading}
      />
    </>
  );
};
export default SurveyDetailsForm;
